import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

/**
 * ProductFaq — kompakte produktbezogene FAQ-Sektion am Ende einer Produktseite.
 *
 * - 3 bis 5 Fragen, Accordion-Logik aus dem bestehenden Shadcn-Set.
 * - Visuelle Sprache identisch zur globalen /faq-Seite, aber kürzer und produktspezifisch.
 * - Erzeugt KEINE eigene FAQPage JSON-LD — der Aufrufer übergibt die gleichen `qa`
 *   bereits an `buildFaqJsonLd(...)` in der SEO-Komponente, um doppelte strukturierte
 *   Daten zu vermeiden.
 */
export default function ProductFaq({ overline = "FAQ", title, qa, productSlug }) {
  return (
    <section
      className="border-t border-[rgba(255,255,255,0.08)] bg-[#0B0F10]"
      data-testid={`product-faq-${productSlug}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="overline mb-4">{overline}</div>
        <h2 className="font-display text-2xl md:text-4xl uppercase leading-[1.1] max-w-3xl">
          {title}
        </h2>

        <div className="mt-10 max-w-4xl">
          <Accordion type="single" collapsible className="border-t border-[rgba(255,255,255,0.08)]">
            {qa.map((row, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[rgba(255,255,255,0.08)]"
                data-testid={`product-faq-${productSlug}-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display uppercase tracking-[0.04em] text-base md:text-lg text-white hover:no-underline py-5">
                  {row.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#AEB7B7] text-sm md:text-base leading-relaxed pb-5 pr-6">
                  {row.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
